module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-brescia.svg?5688071351e482b656008d9cdd665022";